export class ChangeLexoRankRequest {
  id: number;
  next: string;
  previous: string;
}
